import * as React from "react";
import { forwardRef } from "react";
const SvgCyberark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#06c", rx: 4 }), /* @__PURE__ */ React.createElement("path", { stroke: "#fff", strokeLinejoin: "round", strokeWidth: 1.5, d: "m12 6-6 4v6l6 4 6-4v-6z" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 14, r: 2, fill: "#fff" }));
const ForwardRef = forwardRef(SvgCyberark);
export default ForwardRef;
